// document.querySelectorAll('.Color-swatches .swatch').forEach(swatch => {
//   swatch.addEventListener('click', function(){

//     document.querySelectorAll('.Color-swatches .swatch').forEach(s => s.classList.remove('active'));
//     this.classList.add('active');

//     let colorName = this.getAttribute('data-color');

//     document.getElementById('pickedName').innerText = colorName;
//     document.querySelector('.Cstm-picker').classList.add('show');

//   });
// });

// Filtro de colores por tamano en la PDP (Classic / Compact).
//
// Que colores se ven en cada tamano sale de los VARIANTES REALES del producto
// (el JSON de <variant-selects>): un color aparece en un tamano solo si existe
// esa combinacion en Shopify. Un color nuevo creado en Shopify aparece solo.
//
// Arreglo del 2026-09-26 (antes esto era una lista fija que corria en window
// "load"):
// - "load" tarda 5-20 s en la PDP; hasta entonces se veian todos los colores y
//   cambiar de tamano no filtraba nada (Grey aparecia en Compact).
// - La lista fija mostraba Ivory en Compact en 6 productos que no lo tienen, y
//   escondia el "Gray" del 10-piece en Classic.
// - Con Grey elegido, pasar a Compact escondia Grey pero Shopify se quedaba en
//   Grey / Classic: se veia Compact y el carrito agregaba Classic. Ahora se
//   elige el primer color valido y se sincroniza el picker de Shopify.
(function () {
  // INTERRUPTOR para esconder un color de un tamano SIN borrar el variante en
  // Shopify (las ordenes viejas necesitan que el variante siga existiendo).
  // Ej. cuando se agoten los sets de Snow: compact: ["snow"].
  // Ver docs/fabric-off-white-joyce-2026-09-15.md
  const hiddenColors = {
    classic: [],
    compact: []
  };

  // Solo si no hay JSON de variantes (no deberia pasar en la PDP).
  const fallbackColors = {
    classic: ["off-white", "ivory", "grey", "gray"],
    compact: ["off-white", "ivory", "snow"]
  };

  const norm = s => (s || "").trim().toLowerCase();

  function getPicker() {
    const box = document.querySelector('.color_option');
    const scope = (box && box.closest('[id^="shopify-section"]')) || document;
    return scope.querySelector('variant-selects');
  }

  function getVariants(picker) {
    const script = picker && picker.querySelector('script[type="application/json"]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function allowedFor(size, variants) {
    const hidden = hiddenColors[norm(size)] || [];
    if (!variants) {
      const list = fallbackColors[norm(size)];
      return list ? list.filter(c => !hidden.includes(c)) : null;
    }
    const allowed = [];
    variants.forEach(v => {
      const opts = (v.options || []).map(norm);
      if (!opts.includes(norm(size))) return;
      opts.forEach(o => {
        if (o !== norm(size) && !hidden.includes(o)) allowed.push(o);
      });
    });
    return allowed.length ? allowed : null;
  }

  function colorBoxes() {
    return Array.from(document.querySelectorAll('.color_option')).map(box => ({
      box,
      input: box.querySelector('input[type="radio"]'),
      value: norm((box.querySelector('.color-value') || {}).textContent)
    }));
  }

  // Deja el picker nativo de Shopify (el que decide que se agrega al carrito)
  // en la misma combinacion que muestra la UI. Se compara contra el id del
  // form, no contra los radios: si el click llega antes de que cargue
  // global.js, los radios quedan bien pero el id no se actualiza.
  function syncShopify(picker, variants, color, size) {
    if (!picker || !variants) return;
    const target = variants.find(v => {
      const opts = (v.options || []).map(norm);
      return opts.includes(norm(color)) && opts.includes(norm(size));
    });
    if (!target) return;

    const section = picker.closest('[id^="shopify-section"]') || document;
    const idInput = section.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput && String(idInput.value) === String(target.id)) return;

    const radios = Array.from(picker.querySelectorAll('input[type="radio"]'));
    const colorInput = radios.find(r => norm(r.value) === norm(color));
    const sizeInput = radios.find(r => norm(r.value) === norm(size));
    if (!colorInput || !sizeInput) return;

    const fire = () => {
      colorInput.checked = true;
      sizeInput.checked = true;
      sizeInput.dispatchEvent(new Event("change", { bubbles: true }));
    };
    if (window.customElements && !customElements.get('variant-selects')) {
      customElements.whenDefined('variant-selects').then(fire);
    } else {
      fire();
    }
  }

  // sync=false solo filtra; sync=true ademas corrige color y carrito.
  function apply(size, sync) {
    const picker = getPicker();
    const variants = getVariants(picker);
    const allowed = allowedFor(size, variants);
    if (!allowed) return;

    const boxes = colorBoxes();
    boxes.forEach(c => {
      c.box.style.display = allowed.includes(c.value) ? "block" : "none";
    });

    if (!sync) return;

    // Si el color elegido no existe en este tamano, pasar al primero que si.
    let current = boxes.find(c => c.input && c.input.checked);
    if (!current || !allowed.includes(current.value)) {
      current = boxes.find(c => allowed.includes(c.value));
      if (!current || !current.input) return;
      current.input.checked = true;
    }
    syncShopify(picker, variants, current.input.value, size);
  }

  // Tambien sincroniza: un click hecho antes de que cargue este script no
  // pasa por el listener de abajo. Si ya coincide, no hace nada.
  function syncFromChecked() {
    const checked = document.querySelector('.option_size input:checked');
    if (checked) apply(checked.value, true);
  }

  // Delegado en document: sirve aunque el input se reemplace despues.
  // setTimeout: deja correr primero el script que copia el click al picker
  // nativo, y despues corrige la combinacion.
  document.addEventListener("change", function (e) {
    const t = e.target;
    if (t && t.matches && t.matches('.option_size input')) {
      setTimeout(() => apply(t.value, true), 0);
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncFromChecked);
  } else {
    syncFromChecked();
  }
  window.addEventListener("load", syncFromChecked);
})();
